import {
  GarageRegisterAnnouncement,
  GarageRegisterAnnouncementCreateDto,
  GarageRegisterAnnouncementUpdateDto,
  GarageRegisterAnnouncementDto,
} from "@/lib/types/garage-register/announcements";

export class GarageRegisterAnnouncementMapper {
  /**
   * Maps API response (Dto) to frontend format
   */
  static fromResponse(dto: GarageRegisterAnnouncementDto): GarageRegisterAnnouncement {
    return {
      id: String(dto.id),
      title: dto.title,
      body: dto.body,
      lifetimeRange: {
        from: new Date(dto.start_at),
        to: new Date(dto.end_at),
      },
      date: new Date(dto.created_at),
      color: dto.color,
      is_archived: dto.is_archived,
      created_by: dto.created_by,
      garage_register: dto.garage_register
        ? {
            id: dto.garage_register.id,
            name: dto.garage_register.name || dto.garage_register.full_garage_name,
            full_garage_name: dto.garage_register.full_garage_name,
          }
        : undefined,
    };
  }

  /**
   * Maps frontend create DTO to API format
   */
  static toCreateDto(
    data: GarageRegisterAnnouncementCreateDto,
    garageRegisterId: string | number
  ): {
    title: string;
    body: string;
    start_at: string;
    end_at: string;
    color: string;
  } {
    return {
      title: data.title,
      body: data.body,
      start_at: data.lifetimeRange.from.toISOString(),
      end_at: data.lifetimeRange.to.toISOString(),
      color: data.color,
    };
  }

  /**
   * Maps frontend update DTO to API format
   */
  static toUpdateDto(
    data: GarageRegisterAnnouncementUpdateDto
  ): Partial<{
    title: string;
    body: string;
    start_at: string;
    end_at: string;
    color: string;
    is_archived: boolean;
  }> {
    const updateData: any = {};

    if (data.title !== undefined) {
      updateData.title = data.title;
    }
    if (data.body !== undefined) {
      updateData.body = data.body;
    }
    if (data.lifetimeRange?.from) {
      updateData.start_at = data.lifetimeRange.from.toISOString();
    }
    if (data.lifetimeRange?.to) {
      updateData.end_at = data.lifetimeRange.to.toISOString();
    }
    if (data.color !== undefined) {
      updateData.color = data.color;
    }
    if (data.is_archived !== undefined) {
      updateData.is_archived = data.is_archived;
    }

    return updateData;
  }
}

